 
import { Observable } from 'rxjs';
import { CompletionMessage, CompletionRequest } from '@app-libs/model';

/**
 * Interface for streaming chat completions
 */
export interface ChatCompletionChunk {
  content: string;
  role?: string;
  finishReason?: 'stop' | 'length' | 'content_filter' | 'function_call';
  usage?: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
    cached_tokens?: number;
  };
}

// Note: StreamCompletionParams and StreamAssistantParams removed - now using unified API


/**
 * Stream processing events
 */
export enum StreamEventType {
  CHUNK_RECEIVED = 'chunk_received',
  STREAM_START = 'stream_start',
  STREAM_COMPLETE = 'stream_complete',
  STREAM_ERROR = 'stream_error',
  TOOL_STARTED = 'tool_started',
  TOOL_EXECUTING = 'tool_executing',
  TOOL_COMPLETED = 'tool_completed',
  TOOL_FAILED = 'tool_failed',
}

/**
 * Stream event data
 */
export interface StreamEvent {
  type: StreamEventType;
  data?: any;
  error?: Error;
  timestamp: Date;
}
